import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [viewersCount, setViewersCount] = useState(0);
  const [selectedFounder, setSelectedFounder] = useState<'cecilia' | 'federico' | null>(null);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Set document head metadata
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const jsonLd = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Event",
          "name": "Curso IA aplicada a tu empresa - MenteIA",
          "description": "Curso presencial de 4 horas sobre inteligencia artificial aplicada a empresas. Aprende prompts efectivos, automatización de tareas y aplicación práctica de IA en tu negocio.",
          "startDate": "2026-01-29T09:00:00-03:00",
          "endDate": "2026-01-29T13:00:00-03:00",
          "eventStatus": "https://schema.org/EventScheduled",
          "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
          "location": {
            "@type": "Place",
            "name": "Hotel Howard Johnson Mayorazgo Paraná",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Etchevehere, Francisco de Miranda Y",
              "addressLocality": "Paraná",
              "addressRegion": "Entre Ríos",
              "postalCode": "E3100",
              "addressCountry": "AR"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "-31.719799",
              "longitude": "-60.530511"
            }
          },
          "image": `${siteUrl}/assets/menteia-logo.png`,
          "organizer": {
            "@type": "Organization",
            "name": "MenteIA",
            "url": siteUrl
          },
          "offers": [
            {
              "@type": "Offer",
              "name": "Entrada Rebajada",
              "price": "85000",
              "priceCurrency": "ARS",
              "availability": "https://schema.org/InStock",
              "validFrom": "2026-01-01T00:00:00-03:00",
              "validThrough": "2026-01-21T00:00:00-03:00",
              "url": siteUrl
            },
            {
              "@type": "Offer",
              "name": "Entrada Normal",
              "price": "105000",
              "priceCurrency": "ARS",
              "availability": "https://schema.org/InStock",
              "validFrom": "2026-01-21T00:00:00-03:00",
              "url": siteUrl
            }
          ],
          "performer": [
            {
              "@type": "Person",
              "name": "Cecilia Ribecco",
              "jobTitle": "Co-Fundadora",
              "description": "Consultora en innovación con inteligencia artificial, especialista en liderazgo, educación y desarrollo emprendedor"
            },
            {
              "@type": "Person",
              "name": "Federico Poiana",
              "jobTitle": "Co-Fundador",
              "description": "Consultor en inteligencia artificial aplicada al marketing y la comunicación digital"
            }
          ]
        },
        {
          "@type": "Course",
          "name": "IA aplicada a tu empresa en 4 horas",
          "description": "Curso presencial intensivo de inteligencia artificial para empresas, emprendedores y profesionales. Aprende a usar IA de forma práctica con plantillas, prompts y casos reales.",
          "provider": {
            "@type": "Organization",
            "name": "MenteIA",
            "sameAs": siteUrl
          },
          "courseCode": "MENTEIA-PARANA-2026",
          "hasCourseInstance": {
            "@type": "CourseInstance",
            "courseMode": "Presencial",
            "duration": "PT4H",
            "startDate": "2026-01-29T09:00:00-03:00",
            "endDate": "2026-01-29T13:00:00-03:00",
            "location": {
              "@type": "Place",
              "name": "Hotel Howard Johnson Mayorazgo Paraná",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Etchevehere, Francisco de Miranda Y",
                "addressLocality": "Paraná",
                "addressRegion": "Entre Ríos",
                "postalCode": "E3100",
                "addressCountry": "AR"
              }
            },
            "instructor": [
              {
                "@type": "Person",
                "name": "Cecilia Ribecco"
              },
              {
                "@type": "Person",
                "name": "Federico Poiana"
              }
            ]
          },
          "offers": {
            "@type": "AggregateOffer",
            "lowPrice": "85000",
            "highPrice": "105000",
            "priceCurrency": "ARS",
            "availability": "https://schema.org/InStock"
          }
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "¿Necesita experiencia previa?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "No. Empezamos desde uso práctico."
              }
            },
            {
              "@type": "Question",
              "name": "¿Puedo pagar en cuotas?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Sí. Con interés. Te pasamos el total al reservar."
              }
            },
            {
              "@type": "Question",
              "name": "¿Hay descuento por transferencia?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Sí. 5% off."
              }
            },
            {
              "@type": "Question",
              "name": "¿Cómo sé que quedé inscripto?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Te confirmamos por WhatsApp cuando entra el pago."
              }
            },
            {
              "@type": "Question",
              "name": "¿Puedo ir con mi socio o equipo?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Sí. Usá pack 2 o pack 3."
              }
            },
            {
              "@type": "Question",
              "name": "¿Qué pasa si me atraso con el precio anticipado?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "La anticipada aplica mientras esté vigente el descuento y haya cupos."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "name": "MenteIA",
          "url": siteUrl,
          "logo": `${siteUrl}/assets/menteia-logo.png`,
          "description": "Formación profesional en inteligencia artificial para empresas y emprendedores en Argentina",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Rosario",
            "addressRegion": "Santa Fe",
            "addressCountry": "AR"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+54-341-577-9623",
            "contactType": "customer service",
            "availableLanguage": "Spanish"
          }
        },
        {
          "@type": "EducationalOrganization",
          "name": "MenteIA",
          "url": siteUrl,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Rosario",
            "addressRegion": "Santa Fe",
            "addressCountry": "AR"
          }
        }
      ]
    };

    // Add JSON-LD script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Set initial random viewers count between 3 and 7
    setViewersCount(Math.floor(Math.random() * 5) + 3);
    
    // Update viewers count every 10-20 seconds
    const interval = setInterval(() => {
      setViewersCount(Math.floor(Math.random() * 5) + 3);
    }, (Math.random() * 10000) + 10000);
    
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const targetDate = new Date('2026-01-28T23:59:59').getTime();
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000)
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const openFounderBio = (founder: 'cecilia' | 'federico') => {
    setSelectedFounder(founder);
  };

  const closeFounderBio = () => {
    setSelectedFounder(null);
  };

  const foundersBios = {
    cecilia: {
      name: 'Cecilia Ribecco',
      role: 'Co-Fundadora',
      bio: [
        // Use backticks to avoid breaking the string with single quotes inside the text
        `Cecilia Ribecco es consultora en innovación con inteligencia artificial, especialista en liderazgo, educación y desarrollo emprendedor. Fundadora y CEO de Business Evolution Mindset®, ha trabajado por más de 15 años asesorando a empresas, instituciones académicas y organismos públicos en Argentina y Latinoamérica. Ha ocupado cargos de liderazgo en organizaciones globales como Women's Entrepreneurship Day Organization (WED), desempeñándose como Embajadora País para Argentina, Presidenta Global de la Iniciativa en América Latina y Embajadora Regional para Sudamérica, impulsando la inclusión de mujeres emprendedoras en más de 144 países. Su trayectoria incluye la vicepresidencia de la Asociación de Emprendedores de Argentina (ASEA), la coordinación del Club de Emprendedores de Rosario, y la integración del Equipo Técnico de Pedagogía Emprendedora del Ministerio de Educación de Santa Fe. Además, ha formado parte del Bureau of the Latin American Association of Design y ha liderado proyectos vinculados a políticas públicas de innovación y formación en emprendimiento. En el ámbito académico, se desempeña como catedrática universitaria en la Universidad del Gran Rosario, dictando asignaturas sobre estrategias de innovación, metodologías de investigación y bases tecnológicas para el desarrollo emprendedor. Cecilia es Licenciada en Educación por la Universidad Empresarial Siglo 21, y cuenta con posgrados y diplomaturas en gestión del emprendimiento, género e inclusión, y tecnologías de la información en instituciones como el Ministerio de Educación de la Nación, la Universidad de la Defensa Nacional (UNDEF), la UNRAF, la Universidad Nacional de General Sarmiento y el Instituto Superior de Diseño CEPEC. A lo largo de su carrera, ha recibido reconocimientos por su liderazgo y compromiso con la equidad, destacándose por impulsar la capacitación, el desarrollo y la visibilidad de mujeres emprendedoras en el ámbito empresarial y social.`
      ]
    },
    federico: {
      name: 'Federico Poiana',
      role: 'Co-Fundador',
      bio: [
        'Federico Poiana es consultor en inteligencia artificial aplicada al marketing y la comunicación digital, con más de 20 años de experiencia en negocios, creatividad y gestión de proyectos internacionales. Es fundador y director de Agencia Sona, donde lidera la estrategia y ejecución de campañas digitales para marcas B2C, B2B e influencers, con un enfoque en la creación de contenidos, la publicidad en redes sociales y la optimización de resultados. Actualmente se desempeña como Social Media Manager en distintas empresas y organizaciones.Su trayectoria incluye experiencia internacional en Irlanda, donde trabajó en el área de Credit Operations y Risk Management Office en Depfa Bank y en el Image Technology Center de Citigroup Irlanda para mercados USA, UK y España, adquiriendo una visión global de procesos corporativos y gestión de riesgos. Formado en Marketing Digital con los profesionales líderes en el mercado, complementó su perfil con certificaciones de Google, orientadas a la aplicación práctica de inteligencia artificial en entornos de negocio. Con un perfil versátil y orientado a resultados, Federico combina su experiencia en creatividad, marketing y trabajo corporativo con el uso estratégico de la inteligencia artificial, facilitando la adopción de nuevas tecnologías para empresas, ONGs y profesionales.'
      ]
    }
  };

  const whatsappNumber = '5493415779623';
  const whatsappMessage = encodeURIComponent('Quiero reservar para Paraná 29/01');
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
  const programLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Quiero recibir el programa del curso')}`;

  return (
    <>      
      <div className="min-h-screen bg-black">
        {/* Navigation */}
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black shadow-md' : 'bg-transparent'}`}>
          <div className="container mx-auto px-6 py-4">
            <div className="flex flex-col md:flex-row items-center justify-between gap-2">
              <Link to="/" className="flex items-center">
                <img 
                  src="https://static.readdy.ai/image/9d306f0d392a82ba4f7ef7b5bf276da1/6b7028e86d250b4304b766fd8606cb84.png" 
                  alt="MenteIA" 
                  className="h-24 w-auto"
                />
              </Link>
              <div className="flex items-center gap-6">
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-2.5 rounded-lg font-medium transition-all duration-300 whitespace-nowrap cursor-pointer bg-teal-500 text-white hover:bg-teal-400 hover:scale-110 hover:shadow-lg hover:shadow-teal-500/50"
                >
                  Reservar
                </a>
              </div>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center justify-center bg-black text-white overflow-hidden pt-48 md:pt-56">
          <div className="absolute inset-0">
            <img 
              src="https://public.readdy.ai/ai/img_res/27a60e5fab3a39e50c33df47a085e2ec.jpg"
              alt="Curso IA MenteIA"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
          </div>
          
          <div className="container mx-auto px-6 relative z-10">
            <div className="max-w-4xl mx-auto text-center">
              <div className="absolute left-0 right-0 bg-black/70 backdrop-blur-sm py-6 -mx-6" style={{ width: '100vw', marginLeft: 'calc(-50vw + 50%)' }}>
                <h1 className="text-5xl md:text-7xl font-bold uppercase tracking-tight px-6">
                  IA aplicada a tu empresa,<br />en 4 horas
                </h1>
              </div>
              <div className="mb-6" style={{ height: '220px' }}></div>
              <div className="inline-block bg-gradient-to-r from-teal-500 to-teal-400 px-8 py-4 rounded-xl mb-8 shadow-2xl border-4 border-white/30">
                <p className="text-2xl md:text-3xl font-black text-white uppercase tracking-wider drop-shadow-lg">
                  Por Única Vez en Paraná
                </p>
              </div>
              <div className="space-y-4 text-xl md:text-2xl">
                <p className="font-medium">Curso presencial en Paraná, Entre Ríos.</p>
                <p className="text-teal-400 font-bold">Jueves 29/01/2026 de 9 a 13hs. La formación incluye Coffee.</p>
                <p className="font-bold">Hotel Howard Johnson</p>
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=Etchevehere,+Francisco+de+Miranda+Y,+E3100+Paraná,+Entre+Ríos"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-teal-400 hover:text-teal-300 transition-colors underline cursor-pointer block text-base md:text-lg"
                >
                  Etchevehere, Francisco de Miranda Y, E3100 Paraná, Entre Ríos
                </a>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-12 mb-10 max-w-3xl mx-auto border border-white/20 md:scale-110">
                <p className="text-xl md:text-2xl mb-6">Cupos restantes: <span className="font-bold text-teal-400">3 personas</span></p>
                
                {/* Countdown Timer */}
                <div className="bg-gradient-to-r from-red-600 to-orange-500 rounded-xl p-4 md:p-8 mb-8 shadow-2xl">
                  <p className="text-white font-bold text-base md:text-lg mb-4 uppercase tracking-wide">
                    ⏰ Comienzo del curso:
                  </p>
                  <div className="grid grid-cols-4 gap-2 md:gap-4">
                    <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2 md:p-4">
                      <div className="text-2xl md:text-4xl lg:text-5xl font-bold text-white">{timeLeft.days}</div>
                      <div className="text-xs md:text-sm text-white/90 uppercase mt-1 md:mt-2">Días</div>
                    </div>
                    <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2 md:p-4">
                      <div className="text-2xl md:text-4xl lg:text-5xl font-bold text-white">{timeLeft.hours}</div>
                      <div className="text-xs md:text-sm text-white/90 uppercase mt-1 md:mt-2">Horas</div>
                    </div>
                    <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2 md:p-4">
                      <div className="text-2xl md:text-4xl lg:text-5xl font-bold text-white">{timeLeft.minutes}</div>
                      <div className="text-xs md:text-sm text-white/90 uppercase mt-1 md:mt-2">Min</div>
                    </div>
                    <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2 md:p-4">
                      <div className="text-2xl md:text-4xl lg:text-5xl font-bold text-white">{timeLeft.seconds}</div>
                      <div className="text-xs md:text-sm text-white/90 uppercase mt-1 md:mt-2">Seg</div>
                    </div>
                  </div>
                  <p className="text-white text-xs md:text-sm mt-4 font-medium">
                    
                  </p>
                </div>

                <div className="space-y-3 text-lg md:text-xl">
                  <p><span className="font-semibold">Entrada:</span> ARS 105.000</p>
                  <p className="text-base text-gray-300 mt-5">Transferencia: 5% off</p>
                  <p className="text-base text-gray-300">Tarjeta: cuotas con interés</p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8 mt-8">
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
                >
                  Reservar por WhatsApp
                </a>
                <a 
                  href={programLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-white text-gray-900 rounded-lg font-semibold text-lg hover:bg-gray-200 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-white/50"
                >
                  Pedir el programa
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Esto es para vos si */}
        <section className="py-20 bg-teal-500">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-12 text-center">
                Esto es para vos si
              </h2>
              
              <div className="grid md:grid-cols-2 gap-6 mb-12">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-building-line text-3xl text-white"></i>
                    </div>
                    <p className="text-white text-lg">Sos dueño de pyme y querés ahorrar tiempo en tareas repetidas.</p>
                  </div>
                </div>
                
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-briefcase-line text-3xl text-white"></i>
                    </div>
                    <p className="text-white text-lg">Sos profesional y necesitás producir mejor, más rápido.</p>
                  </div>
                </div>
                
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-rocket-line text-3xl text-white"></i>
                    </div>
                    <p className="text-white text-lg">Sos emprendedor y hacés de todo.</p>
                  </div>
                </div>
                
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className="ri-team-line text-3xl text-white"></i>
                    </div>
                    <p className="text-white text-lg">Liderás un equipo y querés un método simple para usar IA sin caos.</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-8 mb-8">
                <p className="text-gray-900 text-lg mb-2">No hace falta ser técnico.</p>
                <p className="text-gray-900 text-lg font-semibold">Sí hace falta venir con ganas de practicar.</p>
              </div>

              <div className="text-center">
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 bg-white text-teal-600 rounded-lg font-semibold text-lg hover:bg-gray-100 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-white/50"
                >
                  Reservar por WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Qué te llevás */}
        <section className="py-20 bg-black">
          <div className="container mx-auto px-6">
            <div className="max-w-5xl mx-auto text-center">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Qué te llevás
              </h2>
              <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
                Salís con material listo para usar.
              </p>

              <div className="grid md:grid-cols-2 gap-8 mb-6 max-w-4xl mx-auto">
                <div className="bg-gray-900 rounded-xl p-8 border border-gray-800">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
                    <i className="ri-file-list-3-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">Plantillas de prompts</h3>
                  <p className="text-gray-400">Para tareas típicas de empresa.</p>
                </div>

                <div className="bg-gray-900 rounded-xl p-8 border border-gray-800">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
                    <i className="ri-layout-grid-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">Estructura para escribir</h3>
                  <p className="text-gray-400">Pedidos claros y repetibles.</p>
                </div>

                <div className="bg-gray-900 rounded-xl p-8 border border-gray-800">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
                    <i className="ri-checkbox-multiple-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">Checklist para elegir tareas</h3>
                  <p className="text-gray-400">Que conviene pasar a IA.</p>
                </div>

                <div className="bg-gray-900 rounded-xl p-8 border border-gray-800">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
                    <i className="ri-flow-chart text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">Flujo simple</h3>
                  <p className="text-gray-400">Para revisar calidad y evitar errores comunes.</p>
                </div>

                <div className="bg-gray-900 rounded-xl p-8 border border-gray-800">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
                    <i className="ri-calendar-check-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">Plan de 30 días</h3>
                  <p className="text-gray-400">Para aplicar lo aprendido en tu trabajo.</p>
                </div>

                <div className="bg-gray-900 rounded-xl p-8 border border-gray-800">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
                    <i className="ri-award-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">Diploma de asistencia</h3>
                  <p className="text-gray-400">Certificado oficial del curso.</p>
                </div>
              </div>

              {/* Imagen del diploma */}
              <div className="bg-gray-900 rounded-xl p-8 mb-12 border border-gray-800 max-w-3xl mx-auto">
                <h3 className="text-2xl font-bold text-white mb-6">Tu diploma de asistencia</h3>
                <div className="bg-gray-900 rounded-lg p-8 shadow-2xl">
                  <img 
                    src="https://static.readdy.ai/image/9d306f0d392a82ba4f7ef7b5bf276da1/e9e4e8878e2544656feb0f0e1f7b99e9.png"
                    alt="Diploma de asistencia MenteIA"
                    className="w-full h-auto rounded-lg"
                  />
                </div>
                <p className="text-gray-400 mt-6 text-lg">
                  Recibís tu diploma al finalizar el curso
                </p>
              </div>

              <div>
                <a 
                  href={programLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
                >
                  Pedir el programa
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Qué vas a practicar */}
        <section className="py-20 bg-gray-900 text-white">
          <div className="container mx-auto px-6">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-4xl md:text-5xl font-bold mb-6 text-center">
                Qué vas a practicar en vivo
              </h2>
              <p className="text-xl text-gray-300 mb-12 text-center">
                Ejemplos de prácticas en clase.
              </p>

              <div className="grid md:grid-cols-3 gap-6 mb-12">
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4">
                    <i className="ri-customer-service-2-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-semibold mb-2">Respuestas a clientes</h3>
                  <p className="text-gray-400 text-sm">Y soporte.</p>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4">
                    <i className="ri-article-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-semibold mb-2">Textos de ventas</h3>
                  <p className="text-gray-400 text-sm">Y mensajes comerciales.</p>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4">
                    <i className="ri-file-text-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-semibold mb-2">Borradores de propuestas</h3>
                  <p className="text-gray-400 text-sm">Y presupuestos.</p>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4">
                    <i className="ri-folder-3-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-semibold mb-2">Organización de información</h3>
                  <p className="text-gray-400 text-sm">Y resumen de documentos.</p>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4">
                    <i className="ri-lightbulb-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-semibold mb-2">Ideas de contenido</h3>
                  <p className="text-gray-400 text-sm">Y piezas para redes.</p>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4">
                    <i className="ri-git-branch-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-semibold mb-2">Estructuras para procesos</h3>
                  <p className="text-gray-400 text-sm">Internos.</p>
                </div>
              </div>

              <div className="bg-teal-500/20 border border-teal-500/30 rounded-xl p-8 mb-8">
                <p className="text-xl text-center font-medium">
                  Traé un caso real de tu actividad. Lo trabajás con guía.
                </p>
              </div>

              <div className="text-center">
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
                >
                  Quiero llevar mi caso
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Programa de 4 horas */}
        <section className="py-20 bg-black">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-12 text-center">
                Programa de 4 horas
              </h2>

              <div className="space-y-6 mb-12">
                <div className="bg-gray-900 rounded-xl p-8 border-l-4 border-teal-500">
                  <h3 className="text-2xl font-bold text-white mb-4">Bloque 1</h3>
                  <ul className="space-y-2 text-gray-300">
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5"></i>
                      <span>Qué puede hacer IA hoy en una empresa.</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5"></i>
                      <span>Qué no conviene delegar.</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5"></i>
                      <span>Cómo evitar salidas flojas.</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-gray-900 rounded-xl p-8 border-l-4 border-teal-500">
                  <h3 className="text-2xl font-bold text-white mb-4">Bloque 2</h3>
                  <ul className="space-y-2 text-gray-300">
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5"></i>
                      <span>Prompts que funcionan.</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5"></i>
                      <span>Formatos de pedido para obtener resultados consistentes.</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-gray-900 rounded-xl p-8 border-l-4 border-teal-500">
                  <h3 className="text-2xl font-bold text-white mb-4">Bloque 3</h3>
                  <ul className="space-y-2 text-gray-300">
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5"></i>
                      <span>Práctica por casos.</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5"></i>
                      <span>Ajustes, iteración, control de calidad.</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-gray-900 rounded-xl p-8 border-l-4 border-teal-500">
                  <h3 className="text-2xl font-bold text-white mb-4">Bloque 4</h3>
                  <ul className="space-y-2 text-gray-300">
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5"></i>
                      <span>Plan de aplicación.</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5"></i>
                      <span>Cómo llevarlo a tu rutina sin frenarte.</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-gray-900 rounded-xl p-8 border-l-4 border-teal-500">
                  <h3 className="text-2xl font-bold text-white mb-4">Cierre</h3>
                  <ul className="space-y-2 text-gray-300">
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-xl mt-0.5"></i>
                      <span>Preguntas y dudas puntuales.</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="text-center">
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
                >
                  Reservar mi lugar
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Cómo se da el curso */}
        <section className="py-20 bg-gray-900 text-white">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-4xl md:text-5xl font-bold mb-12">
                Cómo se da el curso
              </h2>

              <div className="grid md:grid-cols-2 gap-6 mb-12">
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-full mb-4 mx-auto">
                    <i className="ri-map-pin-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Presencial</h3>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-full mb-4 mx-auto">
                    <i className="ri-hand-heart-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Práctico</h3>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-full mb-4 mx-auto">
                    <i className="ri-footprint-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Paso a paso</h3>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-full mb-4 mx-auto">
                    <i className="ri-edit-box-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Ejercicios guiados</h3>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-full mb-4 mx-auto">
                    <i className="ri-file-copy-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Plantillas para copiar y adaptar</h3>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-full mb-4 mx-auto">
                    <i className="ri-computer-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Traer notebook para practicar</h3>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Quiénes lo dan */}
        <section className="py-20 bg-black">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 text-center">
                Quiénes lo dan
              </h2>
              <p className="text-2xl text-gray-300 mb-12 text-center">
                MenteIA, Rosario, Argentina.
              </p>

              <div className="grid md:grid-cols-2 gap-8 mb-12">
                <div className="bg-gray-900 rounded-xl p-8 text-center border border-gray-800">
                  <div 
                    className="w-full aspect-square rounded-full mx-auto mb-4 overflow-hidden cursor-pointer relative group"
                    onClick={() => openFounderBio('cecilia')}
                  >
                    <iframe
                      src="https://www.youtube.com/embed/9FYNoxksHD8?autoplay=1&mute=1&loop=1&playlist=9FYNoxksHD8&controls=0&showinfo=0&modestbranding=1&rel=0"
                      width="100%"
                      height="100%"
                      allow="autoplay; fullscreen"
                      className="w-full h-full object-cover"
                      title="Video Cecilia Ribecco"
                      style={{ border: 'none', pointerEvents: 'none' }}
                    ></iframe>
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                      <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-teal-500 text-white px-4 py-2 rounded-lg font-semibold">
                        Ver biografía
                      </div>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">Cecilia Ribecco</h3>
                  <p className="text-gray-400">Co-Fundadora</p>
                  <button
                    onClick={() => openFounderBio('cecilia')}
                    className="mt-4 text-teal-400 hover:text-teal-300 transition-colors font-medium cursor-pointer"
                  >
                    Ver biografía completa
                  </button>
                </div>

                <div className="bg-gray-900 rounded-xl p-8 text-center border border-gray-800">
                  <div 
                    className="w-full aspect-square rounded-full mx-auto mb-4 overflow-hidden cursor-pointer relative group"
                    onClick={() => openFounderBio('federico')}
                  >
                    <iframe
                      src="https://www.youtube.com/embed/u6gXU-G3M0Y?autoplay=1&mute=1&loop=1&playlist=u6gXU-G3M0Y&controls=0&showinfo=0&modestbranding=1&rel=0"
                      width="100%"
                      height="100%"
                      allow="autoplay; fullscreen"
                      className="w-full h-full object-cover"
                      title="Video Federico Poiana"
                      style={{ border: 'none', pointerEvents: 'none' }}
                    ></iframe>
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                      <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-teal-500 text-white px-4 py-2 rounded-lg font-semibold">
                        Ver biografía
                      </div>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">Federico Poiana</h3>
                  <p className="text-gray-400">Co-Fundador</p>
                  <button
                    onClick={() => openFounderBio('federico')}
                    className="mt-4 text-teal-400 hover:text-teal-300 transition-colors font-medium cursor-pointer"
                  >
                    Ver biografía completa
                  </button>
                </div>
              </div>

              <div className="text-center">
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
                >
                  Hablar por WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Entradas y packs */}
        <section className="py-20 bg-teal-500">
          <div className="container mx-auto px-6">
            <div className="max-w-6xl mx-auto">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-12 text-center">
                Entradas y packs
              </h2>

              <div className="grid md:grid-cols-3 gap-8 mb-12">
                {/* Entrada individual */}
                <div className="bg-white rounded-xl p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Entrada individual</h3>
                  <div className="space-y-4 mb-6">
                    <div>
                      <p className="text-3xl font-bold text-gray-900">ARS 105.000</p>
                      <p className="text-xs text-gray-500">total</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Transferencia:</p>
                      <p className="text-sm font-semibold text-gray-900">ARS 99.750</p>
                    </div>
                  </div>
                </div>

                {/* Pack 2 */}
                <div className="bg-white rounded-xl p-8 border-4 border-white shadow-xl transform md:scale-105">
                  <div className="bg-teal-600 text-white text-sm font-bold py-1 px-4 rounded-full inline-block mb-4">
                    PACK EQUIPO
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">Pack 2</h3>
                  <div className="space-y-4 mb-6">
                    <div>
                      <p className="text-3xl font-bold text-gray-900">ARS 185.000</p>
                      <p className="text-xs text-gray-500">total</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Transferencia:</p>
                      <p className="text-sm font-semibold text-gray-900">ARS 175.750</p>
                    </div>
                  </div>
                </div>

                {/* Pack 3 */}
                <div className="bg-white rounded-xl p-8">
                  <div className="bg-teal-600 text-white text-sm font-bold py-1 px-4 rounded-full inline-block mb-4">
                    PACK EQUIPO
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">Pack 3</h3>
                  <div className="space-y-4 mb-6">
                    <div>
                      <p className="text-3xl font-bold text-gray-900">ARS 280.000</p>
                      <p className="text-xs text-gray-500">total</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Transferencia:</p>
                      <p className="text-sm font-semibold text-gray-900">ARS 266.000</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-8 border border-white/20">
                <h3 className="text-xl font-bold text-white mb-4">Reglas del pack</h3>
                <ul className="space-y-2 text-white">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-xl mt-0.5"></i>
                    <span>Un solo pagador.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-xl mt-0.5"></i>
                    <span>Un solo comprobante.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-xl mt-0.5"></i>
                    <span>Pasás nombres por WhatsApp.</span>
                  </li>
                </ul>
              </div>

              {/* Live viewers indicator */}
              <div className="flex items-center justify-center gap-3 mb-8 bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 border border-white/20 max-w-md mx-auto">
                <div className="relative">
                  <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
                  <div className="absolute inset-0 w-3 h-3 bg-red-500 rounded-full animate-ping"></div>
                </div>
                <p className="text-white font-medium text-sm">
                  <span className="font-bold">{viewersCount}</span> personas viendo esta formación ahora
                </p>
              </div>

              <div className="text-center">
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 bg-white text-teal-600 rounded-lg font-semibold text-lg hover:bg-gray-100 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-white/50"
                >
                  Quiero pack equipo
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Cómo reservar */}
        <section className="py-20 bg-black">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-12 text-center">
                Cómo reservar
              </h2>

              <div className="space-y-6 mb-12">
                <div className="flex items-start gap-6 bg-gray-900 rounded-xl p-8 border border-gray-800">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-full font-bold text-xl flex-shrink-0">
                    1
                  </div>
                  <div>
                    <p className="text-lg text-white">
                      Mandás WhatsApp con: <span className="font-semibold">"Quiero reservar para Paraná 29/01"</span>
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6 bg-gray-900 rounded-xl p-8 border border-gray-800">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-full font-bold text-xl flex-shrink-0">
                    2
                  </div>
                  <div>
                    <p className="text-lg text-white mb-3">Te enviamos:</p>
                    <ul className="space-y-2 text-gray-300">
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-teal-500 text-xl mt-0.5"></i>
                        <span>Total a pagar</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-teal-500 text-xl mt-0.5"></i>
                        <span>Link de Mercado Pago o datos de transferencia</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-teal-500 text-xl mt-0.5"></i>
                        <span>Confirmación de cupo</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="flex items-start gap-6 bg-gray-900 rounded-xl p-8 border border-gray-800">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-full font-bold text-xl flex-shrink-0">
                    3
                  </div>
                  <div>
                    <p className="text-lg text-white">
                      Reservás con el pago.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-teal-500/20 border-l-4 border-teal-500 rounded-lg p-6 mb-12">
                <p className="text-lg text-white font-semibold">
                  Cupos restantes disponibles 3
                </p>
              </div>

              <div className="text-center">
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-12 py-5 bg-teal-500 text-white rounded-lg font-bold text-xl hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-2xl hover:shadow-teal-500/50"
                >
                  Reservar por WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Preguntas frecuentes */}
        <section className="py-20 bg-gray-900 text-white">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-4xl md:text-5xl font-bold mb-12 text-center">
                Preguntas frecuentes
              </h2>

              <div className="space-y-4">
                {[
                  {
                    q: '¿Necesita experiencia previa?',
                    a: 'No. Empezamos desde uso práctico.'
                  },
                  {
                    q: '¿Puedo pagar en cuotas?',
                    a: 'Sí. Con interés. Te pasamos el total al reservar.'
                  },
                  {
                    q: '¿Hay descuento por transferencia?',
                    a: 'Sí. 5% off.'
                  },
                  {
                    q: '¿Cómo sé que quedé inscripto?',
                    a: 'Te confirmamos por WhatsApp cuando entra el pago.'
                  },
                  {
                    q: '¿Puedo ir con mi socio o equipo?',
                    a: 'Sí. Usá pack 2 o pack 3.'
                  },
                  {
                    q: '¿Qué pasa si me atraso con el precio anticipado?',
                    a: 'La anticipada aplica mientras esté vigente el descuento y haya cupos.'
                  }
                ].map((faq, index) => (
                  <div key={index} className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 overflow-hidden">
                    <button
                      onClick={() => toggleFaq(index)}
                      className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-white/5 transition-all cursor-pointer"
                    >
                      <h3 className="text-lg font-semibold pr-4">{faq.q}</h3>
                      <i className={`ri-arrow-${openFaq === index ? 'up' : 'down'}-s-line text-2xl text-teal-400 flex-shrink-0`}></i>
                    </button>
                    {openFaq === index && (
                      <div className="px-8 pb-6">
                        <p className="text-gray-300">{faq.a}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div className="text-center mt-12">
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
                >
                  Reservar ahora
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-teal-500 text-white py-12">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto text-center">
              <div className="mb-8">
                <img 
                  src="https://static.readdy.ai/image/9d306f0d392a82ba4f7ef7b5bf276da1/1c933e9a80936fbdcb32303c9f264755.png" 
                  alt="MenteIA" 
                  className="h-32 w-auto mx-auto"
                />
              </div>
              
              <h3 className="text-2xl font-bold mb-4">Curso presencial MenteIA en Paraná</h3>
              <div className="space-y-2 text-lg mb-8">
                <p>Jueves 29/01/2026 de 9 a 13hs</p>
                <p>Hotel Howard Johnson</p>
                <p className="font-semibold">Cupos restantes disponibles 3</p>
              </div>

              {/* Mapa de ubicación */}
              <div className="bg-gray-900 rounded-xl p-8 mb-12 border border-gray-800 max-w-3xl mx-auto">
                <h3 className="text-2xl font-bold text-white mb-6">Ubicación del evento</h3>
                <div className="bg-white rounded-lg overflow-hidden shadow-2xl">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3393.3747837437474!2d-60.53271598481205!3d-31.71979898133095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b5a9c4e02fd6f3%3A0x7e0b5f5c5d5e5f5e!2sHotel%20Howard%20Johnson%20Mayorazgo%20Paran%C3%A1!5e0!3m2!1ses!2sar!4v1642000000000!5m2!1ses!2sar"
                    width="100%"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Ubicación Hotel Howard Johnson Paraná"
                  ></iframe>
                </div>
                <p className="text-white mt-6 text-lg">
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=Etchevehere,+Francisco+de+Miranda+Y,+E3100+Paraná,+Entre+Ríos"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-teal-400 transition-colors underline cursor-pointer"
                  >
                    Etchevehere, Francisco de Miranda Y, E3100 Paraná, Entre Ríos
                  </a>
                </p>
              </div>

              <div>
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 bg-white text-teal-600 rounded-lg font-semibold text-lg hover:bg-gray-100 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-white/50"
                >
                  Reservar por WhatsApp
                </a>
              </div>
            </div>
          </div>
        </footer>

        {/* Founder Bio Popup */}
        {selectedFounder && (
          <div 
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-6 overflow-y-auto"
            onClick={closeFounderBio}
          >
            <div 
              className="bg-gray-900 rounded-2xl max-w-2xl w-full p-8 border border-gray-800 relative my-8 max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={closeFounderBio}
                className="sticky top-0 float-right w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 rounded-full transition-colors cursor-pointer z-10"
              >
                <i className="ri-close-line text-2xl text-white"></i>
              </button>

              <div className="text-center mb-6">
                <h3 className="text-3xl font-bold text-white mb-2">
                  {foundersBios[selectedFounder].name}
                </h3>
                <p className="text-teal-400 text-lg font-medium">
                  {foundersBios[selectedFounder].role}
                </p>
              </div>

              <div className="space-y-4">
                {foundersBios[selectedFounder].bio.map((paragraph, index) => (
                  <p key={index} className="text-gray-300 text-lg leading-relaxed">
                    {paragraph}
                  </p>
                ))}
              </div>

              <div className="mt-8 text-center">
                <button
                  onClick={closeFounderBio}
                  className="px-6 py-3 bg-teal-500 text-white rounded-lg font-semibold hover:bg-teal-400 transition-all duration-300 cursor-pointer"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
